import { memo } from 'react';
import { StepViewComponent } from '../stepDescriptor/types';
import { Instruction } from './Instruction';

export const InstructionViewComponent: StepViewComponent = memo(
  ({ complete, responseIndex, readOnly }) => {
    return (
      <Instruction
        responseIndex={responseIndex}
        complete={complete}
        readOnly={readOnly}
        isPinned={false}
      />
    );
  },
);
